import React from 'react';

import ResponsiveContainer from 'components/ResponsiveContainer';
import ApurementDossier from 'pages/admin-fonctionnel/AdministrationAvancee/ApurementDossier/ApurementDossier';
import ExportStatistiques from 'pages/admin-fonctionnel/AdministrationAvancee/ExportStatistiques/ExportStatistiques';

import ActionCamundaSuppressionMasse from './ActionCamundaSupressionMasse/ActionCamundaSuppressionMasse';
import RecuperationActionsUtilisateur from './RecuperationActionsUtilisateur/RecuperationActionsUtilisateur';

const PageAdministrationAvancee: React.FC = () => {
  return (
    <ResponsiveContainer>
      <h1>Administration avancée</h1>
      <RecuperationActionsUtilisateur />
      <ActionCamundaSuppressionMasse />
      <ApurementDossier />
      <ExportStatistiques />
    </ResponsiveContainer>
  );
};

export default PageAdministrationAvancee;
